import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, inject, OnInit, signal, ViewChild, WritableSignal } from '@angular/core';
import {MatTooltipModule} from '@angular/material/tooltip';
import { SwiperContainer } from 'swiper/element';
 import { SwiperOptions } from 'swiper/types';
 import { register } from 'swiper/element/bundle';
import { PlayersService } from '../../../services/players/players';
import { DomSanitizer } from '@angular/platform-browser';
import { IField } from '../../../model/i-field';
import { environmentDev } from '../../../../../environments/environment.dev';
import { FieldBuilder } from '../../../services/fields/field-builder';
import { Subscription } from 'rxjs';
import { RdGameService } from '../../../services/games/rd-game';
import { AllStatus } from '../../../../core/services/status/all-status';


@Component({
  selector: 'app-play-field-circle',
  imports:  [CommonModule, MatTooltipModule],
  templateUrl: './play-field-circle.html',
  styleUrl: './play-field-circle.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PlayFieldCircle implements OnInit{
  players = inject(PlayersService);
  sanitizer = inject(DomSanitizer);
  fieldBuilder = inject(FieldBuilder);
  subGameInfo: Subscription;
  rdb = inject(RdGameService);
  @ViewChild('swiperCircle') swiperContainer?: ElementRef<SwiperContainer>;
  initialSlideIndex: number = 1;

  public allStatus$ = inject(AllStatus);

  fields: IField[] = this.fieldBuilder.listFields;

  private firstStart: boolean = false;
  private pendingTurningPlayerId: number | null = null;


  
  config: SwiperOptions;

  constructor(private cdref: ChangeDetectorRef) { register(); }

  ngOnDestroy(): void {
    if(this.subGameInfo){
      this.subGameInfo.unsubscribe();
    }
  }

  ngOnInit() { 
    this.firstStart = false;
    this.fields = this.fieldBuilder.listFields;
    
    if(this.players.players.length > 1){      
      this.setConfigSwiper();
    }
    if(sessionStorage.getItem('countPlayers') !== null){
      this.subGameInfo = this.rdb.value$.subscribe((gameInfo:any)=>{
        if(gameInfo){
          let countPlayer = parseInt(sessionStorage.getItem('countPlayers') as string);
          if( countPlayer > gameInfo.players.length){
            // const acField = this.getAcFields(gameInfo.playersFields);
            // this.fieldBuilder.rebuildField(acField);
            // this.fields = this.fieldBuilder.listFields;
            // sessionStorage.setItem('countPlayers', gameInfo.players.length);
          }
          if(this.players.players.length > 1){
            //if(this.firstStart){
              this.pendingTurningPlayerId = gameInfo.turning_player_id;
              this.showTurningPlayer();
            //}else{
              //this.firstStart = true;
            //}
          }
        }
      });
    }
    
  }

  addOpacity(color: string):string{
    return color + 33;
  }

  private getAcFields(playersFields:any){
    let fields: Array<number> = [];
    playersFields.forEach((item: any)=>{
      item.playerField.forEach((list:number)=>{
        fields.push(list);
      });
    });
    return fields;
  }
        
  setConfigSwiper(){
    this.config = {
      effect: 'cards',
      slidesPerView: 1,
      initialSlide: 0,
      loop: false,
      allowTouchMove: false,
      simulateTouch: false,
      speed: 300,
      cardsEffect: {
        perSlideOffset: 8,
        perSlideRotate: 2,
        rotate: true,
        slideShadows: false,
      }
    };
  }

  ngAfterViewInit() {
    // const swiperEl: any = document.querySelector('.swiper-container-circle');
    if (!this.swiperContainer || !this.config) {
      return;
    }

    Object.assign(this.swiperContainer.nativeElement, this.config);

    //swiperEl.initialize();
      this.swiperContainer.nativeElement.initialize();
      this.showTurningPlayer();
    //}
  }

  private showTurningPlayer(): void {
    if (!this.swiperContainer || this.pendingTurningPlayerId === null) {
      return;
    }

    const turningPlayer = this.players.players.find(
      (player: any) => player.player_id === this.pendingTurningPlayerId
    );

    const position = (turningPlayer?.rq_id > 100)?(turningPlayer?.rq_id - 100) : turningPlayer?.dice_sum;
    

    if (position === null || position === undefined) {
      return;
    }

    const visibleFields = this.fields.filter(field => field.style === 'show-field');
    const slideIndex = visibleFields.findIndex(field => field.position === position);

    if (slideIndex >= 0) {
      this.swiperContainer.nativeElement.swiper.slideTo(slideIndex, 300, false);
    }
  }


  styleField(position: number, stl: string){
    let style: Array<string> = ["default"];
    style.push(stl);
    if(position === this.players.player.dice_sum){
      style.push('active-field');
      //this.changeSwiper();
    }else{
      if(position < (this.players.player.dice_sum as number)){
        style.push('passive-field');
      }
    }
    return style.join(" ");
  }
  
}
